module.exports = {
      id: "ic-synth-normal-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#ic-synth-normal-usage",
      toString: function () {
        return this.url;
      }
    }